import { Doughnut } from 'react-chartjs-2'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import type { QuantumDist } from '@/api/types'

ChartJS.register(ArcElement, Tooltip, Legend)

// Quantum-risk posture colors: vulnerable → safe (worst → best), unknown neutral.
const QR_COLORS = ['#C22221', '#e8734f', '#eab308', '#22c55e', '#94a3b8']

export function QuantumRiskDonut({
  dist,
  showLegend = true,
}: {
  dist: QuantumDist
  showLegend?: boolean
}) {
  const data = {
    labels: ['Vulnerable', 'Partial', 'Hybrid', 'Safe', 'Unknown'],
    datasets: [
      {
        data: [dist.vulnerable, dist.partial, dist.hybrid, dist.safe, dist.unknown],
        backgroundColor: QR_COLORS,
        borderWidth: 0,
      },
    ],
  }
  return (
    <Doughnut
      data={data}
      options={{
        cutout: '62%',
        responsive: true,
        maintainAspectRatio: showLegend,
        plugins: {
          legend: showLegend
            ? { position: 'right', labels: { boxWidth: 12, font: { size: 11 } } }
            : { display: false },
        },
      }}
    />
  )
}
